import { Tooltip } from "flowbite-react";
import React from "react";
import { Link } from "react-router-dom";
import DefaultButton from "./defaultButton";

const variantStyles = {
  default: "bg-primary-900 text-white rounded-md hover:bg-gradient-to-r hover:from-[#1E3A8A] hover:to-[#3B82F6] border-0",
  primary:
    "bg-primary-900 text-white rounded-md hover:bg-gradient-to-r hover:from-[#1E3A8A] hover:to-[#3B82F6] border-0",
  secondary:
    "bg-light text-theme rounded-md hover:bg-bghoverlight border-0 border-textLight",
  outline:
    "px-2 bg-white hover:bg-gray-100 border border-primary-900 rounded-md",
  iconButton:
    "w-8 h-8 p-0 justify-center items-center rounded-md text-primary-900 hover:text-theme hover:bg-bghoverlight bg-light ",
};

const sizeStyles = {
  default: "min-h-8 min-w-8",
  sm: "h-8 rounded-md",
  md: "h-10 rounded-md",
  lg: "h-12 rounded-md",
  icon: "h-10 w-10",
};

const LinkButton = ({
  name,
  onClick,
  icon,
  iconClass,
  classnames,
  onPress,
  state = null,
  variant = "default",
  size = "default",
  tooltip = "",
  disabled = false,
  target=""
}) => {
  const variantClass = variantStyles[variant] || variantStyles.default;
  const sizeClass = sizeStyles[size] || sizeStyles.default;

  return disabled ?
    <DefaultButton
      name={name}
      variant="secondary"
      icon={icon}
      disabled
    /> :
    icon && !name && tooltip ? (
      <Tooltip className="text-xs" content={name || tooltip}>
        <Link
          state={state}
          to={onClick}
          target={target}
          className={`flex items-center justify-center text-sm disabled:pointer-events-none gap-1 disabled:opacity-50 
                px-2 ${variantClass} ${sizeClass} ${classnames}`}
        >
          {icon && <span className={iconClass}>{icon}</span>}
          {name}
        </Link>
      </Tooltip>
    ) : (
      <Link
        state={state}
        to={onClick}
        target={target}
        className={`flex items-center justify-center text-sm disabled:pointer-events-none gap-1 disabled:opacity-50 
        px-2 ${variantClass} ${sizeClass} ${classnames}`}
      >
        {icon && <span className={iconClass}>{icon}</span>}
        {name}
      </Link>
    );
};

export default LinkButton;
